var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.changePassword_title } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-start mb-5" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "4", sm: "3", md: "2", xl: "1" } },
                    [
                      _c("back-button", {
                        attrs: { returnUrl: _vm.returnUrl },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                {
                  staticClass:
                    "ml-5 mb-4 mr-5 mr-5 form-group font-weight-bold",
                },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "5" } },
                    [
                      _c("form-read-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("common.idtfr"),
                          inputValue: _vm.login,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.connectToGoogle
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "5" } },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("common.orig_pwd"))),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(" *"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "d-flex" }, [
                            _vm.currentPasswordType === "checkbox"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.originalPassword,
                                      expression: "originalPassword",
                                    },
                                  ],
                                  staticClass:
                                    "form-control inputAccordionForm h-30px",
                                  attrs: {
                                    placeholder: _vm.$t("common.orig_pwd"),
                                    type: "checkbox",
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.originalPassword)
                                      ? _vm._i(_vm.originalPassword, null) > -1
                                      : _vm.originalPassword,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.originalPassword,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.originalPassword = $$a.concat([
                                              $$v,
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.originalPassword = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.originalPassword = $$c
                                      }
                                    },
                                  },
                                })
                              : _vm.currentPasswordType === "radio"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.originalPassword,
                                      expression: "originalPassword",
                                    },
                                  ],
                                  staticClass:
                                    "form-control inputAccordionForm h-30px",
                                  attrs: {
                                    placeholder: _vm.$t("common.orig_pwd"),
                                    type: "radio",
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.originalPassword, null),
                                  },
                                  on: {
                                    change: function ($event) {
                                      _vm.originalPassword = null
                                    },
                                  },
                                })
                              : _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.originalPassword,
                                      expression: "originalPassword",
                                    },
                                  ],
                                  staticClass:
                                    "form-control inputAccordionForm h-30px",
                                  attrs: {
                                    placeholder: _vm.$t("common.orig_pwd"),
                                    type: _vm.currentPasswordType,
                                  },
                                  domProps: { value: _vm.originalPassword },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.originalPassword = $event.target.value
                                    },
                                  },
                                }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "icon icon-password mt-2 pt-1 icon-field",
                              class: [
                                _vm.isCurrentPasswordFieldHidden
                                  ? "fa-duotone fa-eye"
                                  : "fa-duotone fa-eye-slash",
                              ],
                              on: { click: _vm.switchCurrentPasswordType },
                            }),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                {
                  staticClass:
                    "ml-5 mb-4 mr-5 mr-5 form-group font-weight-bold",
                },
                [
                  !_vm.connectToGoogle
                    ? _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "5" } },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("common.new_pwd"))),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(" *"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "d-flex" }, [
                            _vm.newPasswordType === "checkbox"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.newPassword,
                                      expression: "newPassword",
                                    },
                                  ],
                                  staticClass:
                                    "form-control inputAccordionForm h-30px",
                                  attrs: {
                                    placeholder: _vm.$t("common.new_pwd"),
                                    type: "checkbox",
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.newPassword)
                                      ? _vm._i(_vm.newPassword, null) > -1
                                      : _vm.newPassword,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.newPassword,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.newPassword = $$a.concat([
                                              $$v,
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.newPassword = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.newPassword = $$c
                                      }
                                    },
                                  },
                                })
                              : _vm.newPasswordType === "radio"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.newPassword,
                                      expression: "newPassword",
                                    },
                                  ],
                                  staticClass:
                                    "form-control inputAccordionForm h-30px",
                                  attrs: {
                                    placeholder: _vm.$t("common.new_pwd"),
                                    type: "radio",
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.newPassword, null),
                                  },
                                  on: {
                                    change: function ($event) {
                                      _vm.newPassword = null
                                    },
                                  },
                                })
                              : _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.newPassword,
                                      expression: "newPassword",
                                    },
                                  ],
                                  staticClass:
                                    "form-control inputAccordionForm h-30px",
                                  attrs: {
                                    placeholder: _vm.$t("common.new_pwd"),
                                    type: _vm.newPasswordType,
                                  },
                                  domProps: { value: _vm.newPassword },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.newPassword = $event.target.value
                                    },
                                  },
                                }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "icon icon-password mt-2 pt-1 icon-field",
                              class: [
                                _vm.isNewPasswordFieldHidden
                                  ? "fa-duotone fa-eye"
                                  : "fa-duotone fa-eye-slash",
                              ],
                              on: { click: _vm.switchNewPasswordType },
                            }),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "5" } },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("common.conf_pwd"))),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(" *"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex" }, [
                        _vm.confirmNewPasswordType === "checkbox"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.confirmNewPassword,
                                  expression: "confirmNewPassword",
                                },
                              ],
                              staticClass:
                                "form-control inputAccordionForm h-30px",
                              attrs: {
                                placeholder: _vm.$t("common.conf_pwd"),
                                type: "checkbox",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.confirmNewPassword)
                                  ? _vm._i(_vm.confirmNewPassword, null) > -1
                                  : _vm.confirmNewPassword,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.confirmNewPassword,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.confirmNewPassword = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.confirmNewPassword = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.confirmNewPassword = $$c
                                  }
                                },
                              },
                            })
                          : _vm.confirmNewPasswordType === "radio"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.confirmNewPassword,
                                  expression: "confirmNewPassword",
                                },
                              ],
                              staticClass:
                                "form-control inputAccordionForm h-30px",
                              attrs: {
                                placeholder: _vm.$t("common.conf_pwd"),
                                type: "radio",
                              },
                              domProps: {
                                checked: _vm._q(_vm.confirmNewPassword, null),
                              },
                              on: {
                                change: function ($event) {
                                  _vm.confirmNewPassword = null
                                },
                              },
                            })
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.confirmNewPassword,
                                  expression: "confirmNewPassword",
                                },
                              ],
                              staticClass:
                                "form-control inputAccordionForm h-30px",
                              attrs: {
                                placeholder: _vm.$t("common.conf_pwd"),
                                type: _vm.confirmNewPasswordType,
                              },
                              domProps: { value: _vm.confirmNewPassword },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.confirmNewPassword = $event.target.value
                                },
                              },
                            }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass:
                            "icon icon-password mt-2 pt-1 icon-field",
                          class: [
                            _vm.isConfirmNewPasswordFieldHidden
                              ? "fa-duotone fa-eye"
                              : "fa-duotone fa-eye-slash",
                          ],
                          on: { click: _vm.switchConfirmNewPasswordType },
                        }),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "form-group justify-content-end mr-5" },
                [
                  _c(
                    "b-col",
                    { attrs: { lg: "2" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            title: _vm.changePassword_Validatechanges,
                            variant: "primary",
                          },
                          on: { click: _vm.changePassword },
                        },
                        [
                          _c("i", { staticClass: "fa-light fa-floppy-disk" }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }